/**
 * Essa classe tem como função exportar todo o contexto de pastas para o Design System
 * Para adicionar uma nova linguagem basta criar um diretório com um index.js. Ex: en/index.js
 */

export default require.context('./', true, /index.js$/i)
